/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{padding-left:20%;height:500vh;overflow:auto;display:block;max-height:100vh}  .swiper-slide--auto{width:30%!important}  .column{width:30%}div.block[_ngcontent-%COMP%]{border:1px solid #000;max-width:100%;overflow-x:auto}div.block[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}ul[_ngcontent-%COMP%]{display:flex;list-style-type:none}"];
export { styles as styles };
